import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/enthymeme.pdf'; 
import { Helmet } from 'react-helmet';

function TrueMethod() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}> 
        Source:<br /><br />
		Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
		Shelfmark LH 4, 3, 5e, Bl. 4<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: 1695 (?)<br /><br />
		Translated from the Latin<br /><br />{isMobile ? '' : <hr className="centered-hr" />}
		<Link to={pdf} target="_blank">View this translation in PDF format (96k)</Link><br /><br />
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On Reducing an Enthymeme to a Single Proposition</title>
            <meta name="description" content="A transcription of ON REDUCING AN ENTHYMEME TO A SINGLE PROPOSITION by GOTTFRIED WILHELM LEIBNIZ, from 1695 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>ON REDUCING AN ENTHYMEME TO A SINGLE PROPOSITION</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 <small>This short piece was written on one side of an irregularly-shaped fragment of paper cut from a larger sheet. The paper bears no watermark but is catalogued among Leibniz's philosophical papers from 1695.</small><br /><br />
                 [<b>LH 4, 3, 5e, Bl. 4</b>]<br /><br />		

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;It pertains to practical logic that people, especially those who hold authority and have the attention of others, often reduce an enthymeme to a single proposition, omitting the conclusion itself. For instance, the King of France,<a name="1" href="#note1"><sup>1</sup></a> upon encountering Dietrich, Alderman of Strasbourg,<a name="2" href="#note2"><sup>2</sup></a> during his passage [through the city], said: “I am going to Mass”. And then, upon on his return, he again addressed him with just these few words: “I am coming from Mass”. As if to say: “you too go to Mass, if you desire my favour”. The syllogism would be: if I go to Mass, then you too should go to Mass. I go to Mass. Therefore, you too should go to it.
                        <br /><br /><br />
                        <hr className='rightcol-hr' />
                        <br /><br />NOTES:<br /><br />
                        <a name="note1" href="#1">1.</a> Above “King of France” Leibniz wrote “Louis XIV”.<br />
                        <a name="note2" href="#2">2.</a> Namely, Dominique Dietrich (1620-1694). A Lutheran by birth, he came under pressure to convert to Catholicism after Strasbourg became a French city in 1681, pressure that was intensified following the Revocation of the Edict of Nantes in October 1685. However, he resisted every attempt to make him change religion.
                <br /><br /><br />
                        &#169; Lloyd Strickland 2022
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default TrueMethod;